export function isValidMongoId(id) {
  if (!id || typeof id !== "string") {
    return false;
  }

  const objectIdPattern = /^[0-9a-fA-F]{24}$/;
  return objectIdPattern.test(id);
}

export function cleanTaxId(obj) {
  if (!obj) return;
  if (
    obj.taxId &&
    (!obj.taxId.type ||
      !["cuil", "cuit"].includes(String(obj.taxId.type).toLowerCase()))
  ) {
    delete obj.taxId;
  }
  return obj;
}
